module.exports = __webpack_public_path__ + "media/allin.f40ec591.mp3";